import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Permission } from 'src/app/constants/permission.constant';
import { AssetsService } from 'src/app/services/assets.service';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-label-data-asset-create',
  templateUrl: './label-data-asset-create.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class LabelDataAssetCreateComponent {
  @Input() assetId!: string;
  @Input() assetType!: string;
  @Input() buttonStyle: 'icon' | 'raised' = 'icon';
  @Input() tooltip = 'Re-extract label from image';
  @Output() extracted = new EventEmitter<void>();

  Permission = Permission;
  extracting = false;

  constructor(
    public authService: AuthService,
    private assetsService: AssetsService,
    private alertService: AlertService,
  ) {}

  onExtract(): void {
    this.extracting = true;
    this.assetsService.extractLabelBoundingBox(this.assetId, this.assetType).subscribe({
      next: () => {
        this.extracting = false;
        this.alertService.successToast('Asset Content Queued for Extraction');
        this.extracted.emit();
      },
      error: () => {
        this.extracting = false;
      },
    });
  }
}
